export const query_autoValutazioneAvvocato_byId = `
query getAutovalutazioneById($id: Int!) {
  autovalutazione_avvocati_by_pk(Id: $id) {
    Id
    TenantId
    AziendaId
    AnalisiNMesi
    AreaGeografica
    IsAreaItalia
    AreaRischioId
    AreaClientiTipoId
    IsMotivoIdent
    ChkMotivoIdent1
    ChkMotivoIdent2
    ChkMotivoIdent3
    ChkMotivoIdent4
    ChkMotivoIdent5
    AttivitaTipicaId
    IsAttivitaContenziosa
    ClientiTipoId
    ClientiSettore
    IsClientiAreaSensibile
    IsClientiProvenienzaVaria
    ClientiProvenienzaId
    ClientiProvenienzaNote
    RisultatiId
    RischioProvvedimentoId
    RischioProvvedimentoNote
    ChkProcedure1
    ChkProcedure2
    ChkProcedure3
    ChkProcedure4
    ChkProcedure5
    ResponsabileId
    Date
    CreatedBy
    ModifiedBy
    CreatedOn
    ModifiedOn
    ProvdedBy
    ExpireDate
    OperateInRisk
    SpecificCase
    WhistleBlowingId
    WhistleBlowingNotes
    TerritoryRisk
  }
}`;
export const query_autoValutazioneAvvocato_byTenant = `
query getAutovalutazioniAvvocatiByTenant($tenantId: String!, $aziendaId : Int!) {
  autovalutazione_avvocati(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq:$aziendaId}}) {
    Id
    TenantId
    AziendaId
    AnalisiNMesi
    AreaGeografica
    IsAreaItalia
    AreaRischioId
    AreaClientiTipoId
    IsMotivoIdent
    ChkMotivoIdent1
    ChkMotivoIdent2
    ChkMotivoIdent3
    ChkMotivoIdent4
    ChkMotivoIdent5
    AttivitaTipicaId
    IsAttivitaContenziosa
    ClientiTipoId
    ClientiSettore
    IsClientiAreaSensibile
    IsClientiProvenienzaVaria
    ClientiProvenienzaId
    ClientiProvenienzaNote
    RisultatiId
    RischioProvvedimentoId
    RischioProvvedimentoNote
    ChkProcedure1
    ChkProcedure2
    ChkProcedure3
    ChkProcedure4
    ChkProcedure5
    ResponsabileId
    Date
    CreatedBy
    ModifiedBy
    CreatedOn
    ModifiedOn
    ProvdedBy
    ExpireDate
    OperateInRisk
    SpecificCase
    WhistleBlowingId
    WhistleBlowingNotes
    TerritoryRisk
  }
}`;
export const query_autoValutazioneAvvocato_byTenant_latest =`
query getAutovalutazioneAvvocatoByTenantLatest($tenantId : String!, $aziendaId : Int!){
  autovalutazione_avvocati(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq:$aziendaId}}, order_by: {CreatedOn: desc}, limit: 1){
    Id
    TenantId
    AziendaId
    Date
    CreatedBy
    ModifiedBy
    CreatedOn
    ModifiedOn
    ProvdedBy
  }
}`;
export const query_autoValutazioneAvv_byExpireDate = `
query getAutovalutazioneByExpireDate($tenantId: String!, $aziendaId: Int!,$dtFrom: date!, $dtTo: date!){
  autovalutazione_avvocati(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
  _and:[
      {ExpireDate: {_gte: $dtFrom}},
      {ExpireDate: {_lte: $dtTo}}
  ]}, order_by: {ExpireDate: desc}){
    Id
    TenantId
    AziendaId
    Date
    CreatedBy
    ModifiedBy
    CreatedOn
    ModifiedOn
    ProvdedBy
    ExpireDate
  }
}`;